export default {"src":"/_next/static/media/fico4.a7328da6.svg","height":50,"width":62};